import { useSelector } from "react-redux";
import { RootState } from "@app/store";
import { OrderSummary } from "@app/domain";
import { toOrderSummary } from "../adapters/toOrderSummary";

/**
 * Read-only counterpart to `useOrderSummary` — reflects the Redux `order`
 * slice for the given key but never dispatches `fetchTrackOrder` itself.
 * `DesktopTrackingShell` uses this to feed the persistent map: some routed
 * page already mounted inside its panel (Home/Order Details/...) owns the
 * actual fetch via `useOrderSummary`, so the shell only needs to observe
 * whatever lands in the store, not request it a second time.
 */
export function useCurrentOrderSummary(trackCode: string, isDropoffTracking: boolean): OrderSummary | undefined {
  const order = useSelector((state: RootState) => state.order);
  const customer = useSelector((state: RootState) => state.customer);
  const service = useSelector((state: RootState) => state.service);
  const setting = useSelector((state: RootState) => state.setting);

  const matches =
    order.trackOrderCode === trackCode &&
    order.isDropoffTracking === isDropoffTracking &&
    order.orderFetchStatus === "succeeded";

  return matches ? toOrderSummary({ order, customer, service, setting, isDropoffTracking }) : undefined;
}
